import * as React from 'react';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { ActiveIngredientAdminModel } from "../../../models/activeIngredient";
import { Editor } from 'primereact/editor';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { groupByReturnArray } from '../../../common/functions/helperFunctions';
import { IngredientSideEffectReactionModel, AnatomicalSystemModel, FrequencyOfReactionModel, IngredientSideEffectReactionContentModel } from "../../../models/sideEffect";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { Lang } from '../../../common/enums';

interface IProps {
  activeIngredient: ActiveIngredientAdminModel,
  handleIngredientSideEffectChange: any,
  removeSideEffectReactionClick: any,
  setIsVisibleSideEffectReactionAddEditDialog: any,
  onAddEditSideEffectReactionClick: any,
  setIsAnatomicalSystemDropdownDisabled: any,
  getContentValue: any
}

interface IState {
  validationMessage: string,
  currentTempId: number
}

class ActiveIngredientTabSideEffects extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: '',
      currentTempId: 0
    };
  }

  handleSideEffectReactionAddEditClick = (ingredientSideEffectReactionId) => {
    if (!ingredientSideEffectReactionId) {

      let currentTempId = this.state.currentTempId - 1;
      let newSideEffectReaction = new IngredientSideEffectReactionModel();
      newSideEffectReaction.anatomicalSystem = new AnatomicalSystemModel();
      newSideEffectReaction.frequencyOfReaction = new FrequencyOfReactionModel();
      let contentList = new Array<IngredientSideEffectReactionContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new IngredientSideEffectReactionContentModel();
        content.langId = parseInt(Lang[k]);
        content.description = '';
        contentList.push(content);
      });

      newSideEffectReaction.ingredientSideEffectReactionContent = contentList;
      newSideEffectReaction.ingredientSideEffectReactionId = currentTempId;

      this.setState({
        currentTempId: currentTempId
      });

      this.handleSideEffectReactionAddButton(newSideEffectReaction, false);
    } else {
      let currentIngredientSideEffectReaction = this.props.activeIngredient.ingredientSideEffect.ingredientSideEffectReactions.
        find(f => f.ingredientSideEffectReactionId == ingredientSideEffectReactionId);
      if (currentIngredientSideEffectReaction) {
        this.handleSideEffectReactionAddButton(currentIngredientSideEffectReaction, true);
      }
      else {
        this.setState({
          validationMessage: 'Eror'
        });
      }
    }
  }

  handleSideEffectReactionAddButton(ingredientSideEffect: IngredientSideEffectReactionModel, isDisabled: boolean) {
    this.props.onAddEditSideEffectReactionClick(ingredientSideEffect)
    this.props.setIsVisibleSideEffectReactionAddEditDialog(true);
    this.props.setIsAnatomicalSystemDropdownDisabled(isDisabled);
  }

  public render() {
    //TODO: Move this logic into method
    const { activeIngredient } = this.props;
    const { ingredientSideEffect } = activeIngredient;
    const { ingredientSideEffectReactions } = activeIngredient.ingredientSideEffect;
    const groupedByAnatomical: Array<any> = groupByReturnArray(ingredientSideEffectReactions, 'anatomicalSystemId');

    let anatomicalSystemContainerElement: Array<any> | null = [];
    if (groupedByAnatomical && groupedByAnatomical.length > 0) {
      for (let i = 0; i < groupedByAnatomical.length; i++) {
        let groupArray: Array<IngredientSideEffectReactionModel> = groupedByAnatomical[i];
        if (groupArray) {
          let groupHeader = (groupArray[0].anatomicalSystem &&
            groupArray[0].anatomicalSystem.anatomicalSystemNameBG &&
            groupArray[0].anatomicalSystem.anatomicalSystemNameEN)
            ? groupArray[0].anatomicalSystem.anatomicalSystemNameBG + " / " + groupArray[0].anatomicalSystem.anatomicalSystemNameEN
            : (groupArray[0].anatomicalSystem &&
              groupArray[0].anatomicalSystem.anatomicalSystemNameBG &&
              !groupArray[0].anatomicalSystem.anatomicalSystemNameEN
            )
              ? groupArray[0].anatomicalSystem.anatomicalSystemNameBG
              : (groupArray[0].anatomicalSystem &&
                !groupArray[0].anatomicalSystem.anatomicalSystemNameBG &&
                groupArray[0].anatomicalSystem.anatomicalSystemNameEN)
                ? groupArray[0].anatomicalSystem.anatomicalSystemNameEN : null;

          let currentGroupContainerElement =
            <div className="p-col-12 p-md-6" key={i} style={{ marginTop: "10px" }} >
              <DataTable
                header={groupHeader}
                value={groupArray}
                dataKey='ingredientSideEffectReactionId'
              >
                <Column
                  header="Frequency of Reaction"
                  field="frequencyOfReaction"
                  style={{ width: "16em" }}
                  body={(rowData, column) =>
                    <div>
                      {rowData.frequencyOfReaction.frequencyName}
                    </div>}
                />
                <Column
                  header="Description"
                  field="description"
                  body={(rowData, column) =>
                    rowData && rowData.ingredientSideEffectReactionContent && rowData.ingredientSideEffectReactionContent.length ?
                      rowData.ingredientSideEffectReactionContent
                        .filter(x => typeof x.description === 'string' && x.description.length > 0)
                        .map(r => r.description)
                        .join(' / ')
                      : null
                  } />
                <Column
                  header="Actions"
                  style={{ textAlign: "center", width: "8em" }}
                  body={(rowData, column) =>
                    <div>
                      <Button
                        type="button"
                        icon="pi pi-pencil"
                        className="p-button-warning"
                        tooltip="Edit"
                        tooltipOptions={{ position: 'top' }}
                        style={{ marginRight: ".5em" }}
                        onClick={() => this.handleSideEffectReactionAddEditClick(rowData.ingredientSideEffectReactionId)}
                      />
                      <Button
                        type="button"
                        icon="pi pi-trash"
                        className="p-button-danger"
                        tooltip="Remove"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() => this.props.removeSideEffectReactionClick(rowData.ingredientSideEffectReactionId)}
                      />
                    </div>
                  }
                />
              </DataTable>
            </div>;
          anatomicalSystemContainerElement.push(currentGroupContainerElement);
        } else {
          continue;
        }
      }
    } else {
      anatomicalSystemContainerElement = null;
    }

    return (
      <div style={{ minHeight: '550px' }}>
        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
        <div className="p-grid p-md-12">
          <div className="p-col-12 p-md-6">
            <label>Summary:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleIngredientSideEffectChange('summary', e.htmlValue) }}
              value={this.props.getContentValue('summary')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Consumer description:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleIngredientSideEffectChange('consumerDescription', e.htmlValue) }}
              value={this.props.getContentValue('consumerDescription')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Overdose description:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleIngredientSideEffectChange('overdoseDescription', e.htmlValue) }}
              value={this.props.getContentValue('overdoseDescription')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Professional description:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleIngredientSideEffectChange('professionalDescription', e.htmlValue) }}
              value={this.props.getContentValue('professionalDescription')}
            />
          </div>
          <div className="p-col-12 p-md-12" style={{ marginTop: "20px" }}>
            <button
              onClick={() => this.handleSideEffectReactionAddEditClick(null)}
              className="btn btn-success"
            // style={{ marginRight: "5px" }}
            >
              Add New Reaction
            </button>
          </div>
          <div className="p-grid p-md-12">
            {anatomicalSystemContainerElement}
          </div>
        </div>
      </div>
    )
  }
}

export default ActiveIngredientTabSideEffects;